export function filesPublicApiOriginFromEnv(): string {
    const filesBase = process.env.REACT_APP_FILES_PUBLIC_BASE_URL || '';
    if (filesBase) {
        try {
            return new URL(filesBase.replace(/\/$/, '')).origin;
        } catch {
            return '';
        }
    }

    const strapiBase = process.env.REACT_APP_STRAPI_API_URL || '';
    if (strapiBase) {
        try {
            return new URL(strapiBase.replace(/\/$/, '')).origin;
        } catch {
            return '';
        }
    }

    return '';
}

export function isStrapiPublicDlPath(pathOrUrl: string | null | undefined): boolean {
    if (pathOrUrl == null) return false;
    const normalized = pathOrUrl.trim();
    if (!normalized) return false;
    if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        try {
            return isStrapiPublicDlPath(new URL(normalized).pathname);
        } catch {
            return false;
        }
    }
    return normalized.includes('/api/public/dl/');
}

export function buildStrapiPublicDlUrl(
    documentId: string,
    options?: { origin?: string; inline?: boolean }
): string {
    const trimmed = documentId.trim();
    if (!trimmed) return '';

    const origin = (options?.origin ?? filesPublicApiOriginFromEnv()).replace(/\/$/, '');
    if (!origin) return '';

    const inline = options?.inline ?? true;
    const query = inline ? '?inline=true' : '';
    return `${origin}/api/public/dl/${encodeURIComponent(trimmed)}${query}`;
}

export function resolveStrapiPublicFileDisplayUrl(pathOrUrl: string | null | undefined): string | null {
    if (pathOrUrl == null) return null;
    const normalized = pathOrUrl.trim();
    if (!normalized) return null;
    if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        return normalized;
    }

    if (!isStrapiPublicDlPath(normalized)) {
        return null;
    }

    const origin = filesPublicApiOriginFromEnv();
    if (!origin) {
        return normalized.startsWith('/') ? normalized : `/${normalized}`;
    }

    const path = normalized.startsWith('/') ? normalized : `/${normalized}`;
    return `${origin}${path}`;
}
